import type { RouteRecordRaw, Router } from 'vue-router'
import featureFlag from '@/config/featureFlag'

const MainRoutes: RouteRecordRaw = {
  path: '/',
  name: 'MainModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '/notAuthorized',
      name: 'NotAuthorized',
      component: () => import('./views/NotAuthorizedPage.vue'),
      meta: {
        layout: 'Default',
      },
    },
    {
      path: '/server-error',
      name: 'ServerError',
      component: () => import('./views/ServerErrorPage.vue'),
      meta: {
        header: true,
      },
    },
    {
      path: '/terms-and-conditions',
      name: 'TermsAndConditions',
      component: () => import('./views/StaticContentPage.vue'),
      meta: {
        header: true,
        type: 'TermsAndConditions',
        title: 'termsAndConditions',
      },
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: () => import('./views/StaticContentPage.vue'),
      meta: {
        header: true,
        type: 'AboutUs',
        title: 'aboutUs',
      },
    },
    {
      path: '/cookie-policy',
      name: 'CookiePolicy',
      component: () => import('./views/StaticContentPage.vue'),
      beforeEnter: (_, __, next) => {
        if (featureFlag.cookiePolicy?.enabled) {
          next()
        } else {
          next({ name: 'NotFound' })
        }
      },
      meta: {
        header: true,
        type: 'CookiePolicy',
        title: 'cookiePolicy',
      },
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import('./views/StaticContentPage.vue'),
      meta: {
        header: true,
        type: 'PrivacyPolicy',
        title: 'privacyPolicy',
      },
    },
    {
      path: '/refund-policy',
      name: 'RefundPolicy',
      component: () => import('./views/StaticContentPage.vue'),
      meta: {
        header: true,
        type: 'RefundPolicy',
        title: 'refundPolicy',
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('./views/NotFoundPage.vue'),
      meta: {
        layout: 'Error',
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(MainRoutes)
}
